@if (contact) {
  <div
    class="contact-avatar"
    [ngClass]="'avatar-' + size"
  [ngStyle]="{
    background: GetAvatarColor(contact.label || contact.email)
  }"
    >
    {{ GetAvatarInitials(contact.label || contact.email) }}
  </div>
}
